export default __webpack_public_path__ + "static/media/ArrowDown.09556589.svg";